<template>
  <div>
    <v-row dense>
      <v-col cols="4">
        <select-branch-model
          v-model="idBranch"
          class="c-input-small"
          dense
          outlined
          hide-details
          label="Cơ sở"
          :auto-select="true"
        ></select-branch-model>
      </v-col>
      <v-col cols="8">
        <input-qr-scan-model
          v-model="code"
          ref="codeRef"
          label="Quét mã tài sàn"
          :disabled="!idBranch"
          @keyupEnter="scanInput"
        ></input-qr-scan-model>
      </v-col>
      <v-col cols="4">
        <div class="fs-14px font-weight-medium success--text">
          NHẬN VỀ x {{ summary.count_return }}
        </div>
      </v-col>
      <v-col cols="4">
        <div class="fs-14px font-weight-medium error--text text-center">
          XUẤT ĐỔI x {{ summary.count_export }}
        </div>
      </v-col>
      <v-col cols="4">
        <div
          class="fs-14px font-weight-medium text-decoration-underline primary--text text-right"
          @click="showDialogOrder"
        >
          {{ order.tracking_id }}
        </div>
      </v-col>
      <v-col cols="12">
        <v-simple-table class="table-padding-2 table-h-36 mb-2">
          <template v-slot:default>
            <thead class="v-data-table-header">
              <tr>
                <th role="columnheader" class="text-center" style="width: 75px">
                  Phân loại
                </th>
                <th role="columnheader" class="text-center" style="width: 75px">
                  Mã
                </th>
                <th role="columnheader" class="text-center" style="width: 75px">
                  Loại tài sản
                </th>
                <th role="columnheader" class="text-center">Tài sản</th>
                <th
                  role="columnheader"
                  class="text-center"
                  style="width: 36px; min-width: 36px"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in items"
                :key="`i_${index}_${item.id}`"
                class="text-center"
              >
                <td>
                  <span
                    class="fs-14px font-weight-medium"
                    :class="{
                      'success--text': !!item.id_order,
                      'error--text': !item.id_order,
                    }"
                  >
                    {{ item.id_order ? "NHẬN VỀ" : "XUẤT ĐỔI" }}
                  </span>
                </td>
                <td>{{ item.name }}</td>
                <td>{{ item.asset_type_name }}</td>
                <td>{{ item.asset_name }}</td>
                <td style="width: 30px; min-width: 30px">
                  <v-icon
                    color="error"
                    class="cursor-pointer"
                    @click="removeItem(item)"
                  >
                    mdi-close
                  </v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-dialog v-model="orderDialog" max-width="400px">
      <DetailDialog
        v-if="orderDialog"
        :order="order"
        @close="hideDialogOrder"
      />
    </v-dialog>

    <v-dialog v-model="uploadDialog" persistent max-width="400px">
      <UploadDialog
        v-if="uploadDialog"
        :order="order"
        @close="hideDialogUpload"
        @finished="onFinished"
      />
    </v-dialog>

    <div class="fixed-bottom-block">
      <v-row dense>
        <v-col cols="6">
          <v-btn
            color="error"
            small
            block
            @click="onReset"
            :disabled="!order.id"
          >
            {{ $t("Làm lại") }}
          </v-btn>
        </v-col>

        <v-col cols="6">
          <v-btn
            color="success"
            small
            block
            @click="saveAndPrint"
            :disabled="!order.id"
          >
            {{ $t("Xác nhận") }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { httpClient } from "@/libs/http";
import {
  ASSET_TYPE,
  ASSET_UID_STATUS,
  IDENTIFICATION_DOCUMENT_NAME,
} from "@/libs/const";
import moment from "moment";

export default {
  name: "Index",
  components: {
    DetailDialog: () => import("@/components/exchange/DetailDialog"),
    UploadDialog: () => import("@/components/exchange/UploadDialog"),
  },
  data: () => ({
    idBranch: null,
    order: {},
    items: [],
    code: null,
    isLoading: false,
    orderDialog: false,
    uploadDialog: false,
    documentName: { ...IDENTIFICATION_DOCUMENT_NAME },
  }),
  computed: {
    scannedCodes() {
      if (!this.items || this.items.length === 0) {
        return [];
      }

      return [...this.items].map((item) => item.code);
    },
    summary() {
      const data = {
        count_bike: 0,
        count_key: 0,
        count_charger: 0,
        count_helmet: 0,

        count_return: 0,
        count_export: 0,
      };

      if (this.order.items && this.order.items.length > 0) {
        for (let i = 0; i < this.order.items.length; i++) {
          const item = this.order.items[i];
          if (item.id_asset_type == ASSET_TYPE.BIKE) {
            data.count_bike++;
          }

          if (item.id_asset_type == ASSET_TYPE.KEY) {
            data.count_key++;
          }

          if (item.id_asset_type == ASSET_TYPE.CHARGER) {
            data.count_charger++;
          }

          if (item.id_asset_type == ASSET_TYPE.HELMET) {
            data.count_helmet++;
          }
        }
      }

      if (this.items && this.items.length > 0) {
        for (let i = 0; i < this.items.length; i++) {
          const item = this.items[i];

          if (item.id_asset_type == ASSET_TYPE.BIKE) {
            if (item.id_order) {
              data.count_bike--;
              data.count_return++;
            } else {
              data.count_bike++;
              data.count_export++;
            }
          }

          if (item.id_asset_type == ASSET_TYPE.KEY) {
            if (item.id_order) {
              data.count_key--;
              data.count_return++;
            } else {
              data.count_key++;
              data.count_export++;
            }
          }

          if (item.id_asset_type == ASSET_TYPE.CHARGER) {
            if (item.id_order) {
              data.count_charger--;
              data.count_return++;
            } else {
              data.count_charger++;
              data.count_export++;
            }
          }

          if (item.id_asset_type == ASSET_TYPE.HELMET) {
            if (item.id_order) {
              data.count_helmet--;
              data.count_return++;
            } else {
              data.count_helmet++;
              data.count_export++;
            }
          }
        }
      }

      return data;
    },
  },
  watch: {},
  mounted() {
    this.getProcessing();
  },
  methods: {
    showDialogOrder() {
      this.orderDialog = true;
    },

    hideDialogOrder() {
      this.orderDialog = false;
    },

    showDialogUpload() {
      this.uploadDialog = true;
    },

    hideDialogUpload() {
      this.uploadDialog = false;
    },

    async finishExchange() {
      try {
        await httpClient.post("/order/v1/exchange-finish", {
          // images: this.images,
          id_order: this.order.id,
        });

        document.getElementById("success_sound_player").play();
        this.onFinished();
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
        this.isLoading = false;
        document.getElementById("error_sound_player").play();
      }
    },

    onReset() {
      httpClient.post("/order/v1/exchange-cancel", {
        id_order: this.order.id,
        id_branch: this.idBranch,
      });

      this.order = {};
      this.items = [];
    },

    onFinished() {
      this.$vToastify.success(this.$t("Đổi xe thành công"));
      this.order = {};
      this.items = [];
    },

    async getProcessing() {
      const { data } = await httpClient.post("/order/v1/exchange-processing");
      if (data && data.id) {
        this.idBranch = data.id_branch;
        this.order = { ...data.order };
        this.items = [...data.items];
      }
    },

    async saveAndPrint() {
      if (this.summary.count_bike == 0) {
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(this.$t("Chưa có xe"));
        return false;
      }

      if (this.summary.count_bike > 1) {
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(this.$t("Quá SL xe đã tối đa"));
        return false;
      }

      if (this.summary.count_key == 0) {
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(this.$t("Chưa có chìa khóa"));
        return false;
      }

      if (this.summary.count_key > this.order.max_key) {
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(this.$t("Quá SL chìa khóa đã tối đa"));
        return false;
      }

      if (this.summary.count_charger > this.order.max_charger) {
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(this.$t("Quá SL sạc đã tối đa"));
        return false;
      }

      if (this.summary.count_helmet > this.order.max_helmet) {
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(this.$t("Quá SL mũ đã tối đa"));
        return false;
      }

      const returnBike = [...this.items].find(
        (item) => item.id_asset_type == ASSET_TYPE.BIKE && !!item.id_order
      );
      const returnKey = [...this.items].find(
        (item) => item.id_asset_type == ASSET_TYPE.KEY && !!item.id_order
      );
      if (
        (returnBike && !returnKey) ||
        (!returnBike && returnKey) ||
        (returnBike &&
          returnKey &&
          returnBike.id != returnKey.id_asset_uid_parent)
      ) {
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(this.$t("Cần trả đúng xe và chìa khóa"));
        return false;
      }

      const exportBike = [...this.items].find(
        (item) => item.id_asset_type == ASSET_TYPE.BIKE && !item.id_order
      );
      const exportKey = [...this.items].find(
        (item) => item.id_asset_type == ASSET_TYPE.KEY && !item.id_order
      );
      if (
        (exportBike && !exportKey) ||
        (!exportBike && exportKey) ||
        (exportBike &&
          exportKey &&
          exportBike.id != exportKey.id_asset_uid_parent)
      ) {
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(this.$t("Cần xuất đúng xe và chìa khóa"));
        return false;
      }

      if (this.isLoading) {
        this.$vToastify.warning(this.$t("messages.loading"));
        return false;
      }
      this.isLoading = true;

      try {
        await httpClient.post("/order/v1/exchange-save-item", {
          id_order: this.order.id,
          id_branch: this.idBranch,
          items: this.items,
        });

        this.isLoading = false;
        this.finishExchange();
        // this.printAddendum();
        // this.showDialogUpload();
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
        this.isLoading = false;
      }
    },

    printAddendum() {
      if (!this.isMobileAgent()) {
        this.downloadPdfServerFilename("/order/v1/generate-exchange-addendum", {
          id_order: this.order.id,
          id_branch: this.idBranch,
          id_account: window.me.id,
        });
      } else {
        httpClient.post("/order/v1/mobile-call-generate-contract", {
          id_order: this.order.id,
          id_branch: this.idBranch,
          id_account: window.me.id,
          print_url: "/order/v1/generate-exchange-addendum",
        });
      }
    },

    removeItem(item) {
      this.items = [...this.items].filter((jtem) => jtem.id != item.id);
    },

    async getDetail({ id_order }) {
      const { data } = await httpClient.post("/order/v1/get-detail", {
        id_order,
      });

      const admin = this.getUrlParameter("admin");
      if (admin == 1 && this.checkPermission(["super_admin"])) {
        this.order = { ...data };
        return true;
      }

      const endTime = moment(data.end_time).unix();
      const nowUnix = moment().unix();

      if (nowUnix > endTime) {
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(this.$t("Đơn quá hạn, không được phép đổi xe"));
        return false;
      }
      this.order = { ...data };
      return true;
    },

    async scanInput() {
      if (!this.code) {
        return false;
      }

      const code = this.code.toUpperCase();

      if (this.scannedCodes.includes(code)) {
        this.code = null;
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(this.$t("Mã đã quét"));
        return false;
      }

      if (this.isLoading) {
        this.$vToastify.warning(this.$t("Loading"));
        return false;
      }

      this.isLoading = true;

      try {
        const { data } = await httpClient.post("/asset/v1/find-uid-by-code", {
          code: code,
        });
        this.code = null;
        this.isLoading = false;

        if (!this.order.id && !data.id_order) {
          document.getElementById("error_sound_player").play();
          this.$vToastify.error(
            this.$t("Quét mã nhận về trước để lấy thông tin khách & đơn hàng")
          );
          return false;
        }

        if (!this.order.id && data.id_order) {
          const resDetail = await this.getDetail({ id_order: data.id_order });
          if (!resDetail) {
            return false;
          }
        }

        if (this.order.id && data.id_order && this.order.id != data.id_order) {
          document.getElementById("error_sound_player").play();
          this.$vToastify.error(
            this.$t("Chỉ được phép nhận về tài sản cùng 1 đơn hàng")
          );
          return false;
        }

        if (!data.id_order && data.status != ASSET_UID_STATUS.AVAILABLE) {
          document.getElementById("error_sound_player").play();
          this.$vToastify.error(this.$t("Tài sản chưa đủ điều kiện XUẤT ĐỔI"));
          return false;
        }

        this.items.push(data);
        document.getElementById("success_sound_player").play();
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
        this.code = null;
        this.isLoading = false;
        document.getElementById("error_sound_player").play();
      }
    },
  },
};
</script>
